<template>
  <Content>
    <template #body>
      <Form
        :scheme="scheme"
        :method-fetch-data="methods.fetchData"
        :method-create-data="methods.createData"
        :method-update-data-idempotent="methods.updateData"
        redirect-to-edit="/users/edit"
      />
    </template>
  </Content>
</template>

<script>
import Form from "@/components/Form";
import Content from "@/layout/Content";

import { createUser, getUser, updateUser } from "@/api/users";
import { UserCreate, UserUpdate } from "@/api/schemes/user";

async function createData(form) {
  return createUser({
    username: form.username,
    password: form.password,
    roles: form.roles || [],
  });
}

async function updateData(id, form) {
  const payload = {
    username: form.username,
    roles: form.roles || [],
    is_active: form.is_active,
  };
  if (form.password && form.password.trim()) {
    payload.password = form.password;
  }
  return updateUser(id, payload);
}

function fetchData(id) {
  return getUser(id);
}

export default {
  components: {
    Content,
    Form,
  },
  data() {
    return {
      methods: {
        createData,
        updateData,
        fetchData,
      },
    };
  },
  computed: {
    scheme() {
      const { id } = this.$route.params;
      return id && this.$route.path.includes("edit") ? UserUpdate : UserCreate;
    },
  },
};
</script>
